import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useLangRedirection = () => {
  const { lang: currentLang } = useParams();
  const navigate = useNavigate();

  const getLangAndRedirect = async () => {
    // const res = await fetch(`tuapipipi`);
    // const data = await res.json();
    // const lang = data.lang;

    // if (currentLang !== lang) {
    //   const pathname = window.location.pathname;
    //   navigate(`/${lang}${pathname.substring(3)}`);
    // }
  };

  useEffect(() => {
    getLangAndRedirect();
  }, []);
};
